import { useNavigate, useLocation } from 'react-router-dom';
import DashboardLayout from '../../common/components/dashboard_layout.component';
import ArrowBackIosOutlinedIcon from '@mui/icons-material/ArrowBackIosOutlined';
import { InvoiceTable } from './InvoiceTable';
import styles from './po_workflow_management.module.css';

export const InvoicePage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { poNumber, invoices, poDetails, fromTab } = location.state || {
    poNumber: '',
    invoices: [],
    poDetails: null,
    fromTab: 'action-required',
  };

  const handleBackClick = () => {
    const tab = (fromTab || 'action-required').toString().trim();
    const suffix = tab && tab !== 'action-required' ? `?tab=${encodeURIComponent(tab)}` : '';
    navigate(`/poWorkflowManagement${suffix}`);
  };

  return (
    <>
      <DashboardLayout padding={true}>
        <div className={styles['po-workflow-container']}>
          <div className={styles['po-workflow-header']}>
            <div className={styles['header-left']}>
              <div className={styles['back-icon-container']} onClick={handleBackClick}>
                <ArrowBackIosOutlinedIcon className={styles['back-icon']} />
              </div>
              <h1 className={styles['page-title']}>{poNumber || 'Invoice Details'}</h1>
            </div>
          </div>

          <InvoiceTable
            poNumber={poNumber}
            invoices={invoices}
            poDetails={poDetails}
            fromTab={fromTab}
          />
        </div>
      </DashboardLayout>
    </>
  );
};
